import { render } from "./ActiveRoleListCard.vue?vue&type=template&id=cc8cbd5e"
import script from "./ActiveRoleListCard.vue?vue&type=script&lang=js"
export * from "./ActiveRoleListCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__